import { t } from "@travily/i18n";
import { HeartToggleButton } from "@ui/components/HeartToggleButton";

export interface CardFavoriteButtonProps {
  className?: string;
  favorited?: boolean;
  /** Name of the card's subject, interpolated into the accessible label ("Save %{name}"). */
  name: string;
  onToggle: () => void;
}

/** Favorite heart for card corners. Slot it into a `CardImage` overlay (or any
 *  absolutely-positioned corner cluster) — positioning stays with the caller. */
export function CardFavoriteButton({ className, favorited, name, onToggle }: CardFavoriteButtonProps) {
  return (
    <HeartToggleButton
      aria-label={t("components.card.save_to_favorites", { name })}
      className={className}
      isSelected={favorited}
      onChange={onToggle}
      size="32"
    />
  );
}
